module.exports = __webpack_public_path__ + "img/RV.2c4f73ae.png";